export default {
  send(eventType, eventName, eventValue) {
    if (typeof ym === 'undefined') {
      console.warn('No Yandex Metrika');
      return;
    }

    if (!pahglobal.yandexMetrikaKey) {
      console.log('No Yandex Metrika key');
    }

    ym(pahglobal.yandexMetrikaKey, eventType, eventName);
  }
}



// WEBPACK FOOTER //
// ./_common/services/ym.service.js